const TRACK_BUGS_URL = 'https://iph0vhcscg.execute-api.us-east-2.amazonaws.com/default/trackBugs';

export const trackBug = async (url: string) => {
  const path = new URL(url).pathname;
  const parts = path.split('/');
  const apiName = parts[parts.length - 1];

  const config = {
    queryParams: {
      bug: apiName,
    },
  };
  callApi(TRACK_BUGS_URL, config, true);
};

export const callApi = async (
  url: string,
  config: any,
  auth: boolean,
  gzip: boolean = false,
  key: string = '',
  method: string = 'GET',
  returnErrorJson: boolean = false,
  signal?: AbortSignal,
  returnErrorStatusCode?: boolean,
  returnHeaders?: boolean
) => {
  let body;
  let queryParams = '';
  let aiSafeMode = false;
  if (config) {
    body = config.body;
    aiSafeMode = Boolean(config.aiSafeMode);

    if (config.queryParams) {
      const paramsKeys = Object.keys(config.queryParams);

      queryParams = paramsKeys
        .map((key, index) => {
          const prefix = index === 0 ? '?' : '';

          return `${prefix}${key}=${config.queryParams[key]}`;
        })
        .join('&');
    }
  }
  let headers = {
    ...config,
    body: JSON.stringify(body),
  };

  if (auth) {
    headers = {
      ...config,
      headers: {
        authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
      mode: 'cors',
      body: JSON.stringify(body),
    };
  }

  if (gzip) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        //'accept-encoding': 'gzip'
      },
      gzip: true,
    };
  }

  if (key) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        'x-api-key': key,
      },
    };
  }

  // Many callers set method on config only; 6th arg defaults to GET. Prefer explicit 6th arg, else config.method.
  const resolvedMethod = (() => {
    const explicit = (method || 'GET').toUpperCase();
    if (explicit !== 'GET') {
      return explicit;
    }
    const fromConfig = config?.method;
    if (fromConfig && typeof fromConfig === 'string') {
      return fromConfig.toUpperCase();
    }
    return 'GET';
  })();

  try {
    let response;
    if (aiSafeMode) {
      // Keep AI-specific request handling opt-in to avoid changing behavior for existing APIs.
      const mergedHeaders: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(headers?.headers || {}),
      };
      if (auth) {
        mergedHeaders['authorization'] = `Bearer ${localStorage.getItem('auth-token')}`;
      }

      if (resolvedMethod === 'POST' || resolvedMethod === 'PUT' || resolvedMethod === 'DELETE') {
        const requestData: RequestInit = {
          method: resolvedMethod,
          headers: mergedHeaders,
        };

        if (body) {
          requestData.body = JSON.stringify(body);
        }

        if (signal) {
          requestData.signal = signal;
        }

        response = await fetch(queryParams ? `${url}${queryParams}` : url, requestData);
      } else {
        const requestData: RequestInit = {
          method: 'GET',
          headers: mergedHeaders,
        };
        if (signal) {
          requestData.signal = signal;
        }
        response = await fetch(`${url}${queryParams}`, requestData);
      }
    } else {
      const requestData: RequestInit = {
        ...headers,
        method: resolvedMethod,
      };
      if (signal) {
        requestData.signal = signal;
      }
      response = await fetch(queryParams ? `${url}${queryParams}` : url, requestData);
    }
    /*
      fetch can either
      - return response
        - success: status_code 200
        - failed: status_code: 4xx, 5xx
      - throw an error
    */
    const json = await response.json();
    if (response.ok) {
      return json;
    } else {
      return returnErrorJson ? {...json, status: response.status} : `${response.status}: ${response.statusText || 'Error'}`;
    }
  } catch (error) {
    // Don't track abort errors as bugs or track bugs url calls
    const isAbort =
      (error instanceof Error && error.name === 'AbortError') ||
      (typeof DOMException !== 'undefined' &&
        error instanceof DOMException &&
        error.name === 'AbortError');
    if (isAbort || url === TRACK_BUGS_URL) {
      throw error;
    }
    trackBug(url);
    return returnErrorJson ? { error: error, status: 400 } : error;
  }
};
